import React from 'react';
import { useMetaPixel } from './components/MetaPixel';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { MythsSection } from './components/MythsSection';
import { FrameworkSection } from './components/FrameworkSection';
import { ValueStackSection } from './components/ValueStackSection';
import { WhoIsThisFor } from './components/WhoIsThisFor';
import { ProofSection } from './components/ProofSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { ClosingSection } from './components/ClosingSection';
export function App() {
  useMetaPixel();
  return <main className="min-h-screen bg-cream selection:bg-gold/30" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainSection data-id="element-2" />
      <MythsSection data-id="element-3" />
      <FrameworkSection data-id="element-4" />
      <ValueStackSection data-id="element-5" />
      <WhoIsThisFor data-id="element-6" />
      <ProofSection data-id="element-7" />
      <GuaranteeSection data-id="element-8" />
      <FAQSection data-id="element-9" />
      <ClosingSection data-id="element-10" />
    </main>;
}